"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var InputSwitch = function InputSwitch(_ref) {
    var children = _ref.children, name = _ref.name, onChange = _ref.onChange, required = _ref.required, checked = _ref.checked, className = _ref.className;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        className: className
    }, /*#__PURE__*/ react_1.default.createElement(Label, null, children), /*#__PURE__*/ react_1.default.createElement(Input, Object.assign({
        type: "checkbox"
    }, {
        name: name,
        onChange: onChange,
        checked: checked
    }, {
        required: !!required
    })), /*#__PURE__*/ react_1.default.createElement(Switch, {
        checked: checked
    }));
}; // Styling
var Wrapper = styled_components_1.default.label.withConfig({
    displayName: "InputSwitch__Wrapper",
    componentId: "q8f1wu-0"
})(["position:relative;display:flex;justify-content:space-between;align-items:center;user-select:none;cursor:pointer;padding:16px 0;", ""], _theme_1.type.labelLarge);
var Input = styled_components_1.default.input.withConfig({
    displayName: "InputSwitch__Input",
    componentId: "q8f1wu-1"
})(["position:absolute;opacity:0;height:0;width:0;"]);
var Switch = styled_components_1.default.span.withConfig({
    displayName: "InputSwitch__Switch",
    componentId: "q8f1wu-2"
})(["position:relative;background-color:", ";width:40px;height:24px;border:1px solid ", ";border-radius:12px;appearance:none;transition:background-color 0.4s ease-in-out,border-color 0.4s ease-in-out;will-change:background-color,border-color;&:after{content:'';position:absolute;left:0;top:3px;display:block;background-color:", ";width:16px;height:16px;border:1px solid ", ";border-radius:100%;transform:translateX(", "px);transition:background-color 0.25s ease-in-out,transform 0.4s ease-in;will-change:background-color,transform;}", "{", ":hover &{border-color:", ";&:after{background-color:", ";}}}"], function (props) {
    return props.checked ? _theme_1.palette.white : _theme_1.palette.snow;
}, function (props) {
    return props.checked ? _utils_1.rgba(_theme_1.palette.ink, 0.64) : _utils_1.rgba(_theme_1.palette.ink, 0.32);
}, function (props) {
    return props.checked ? _utils_1.rgba(_theme_1.palette.green, 0.8) : _utils_1.rgba(_theme_1.palette.ink, 0.24);
}, function (props) {
    return props.checked ? _utils_1.rgba(_theme_1.palette.ink, 0.32) : _utils_1.rgba(_theme_1.palette.ink, 0.24);
}, function (props) {
    return props.checked ? 19 : 4;
}, _utils_1.mediaQuery('tablet'), Wrapper, _utils_1.rgba(_theme_1.palette.ink, 0.64), function (props) {
    return props.checked ? _utils_1.rgba(_theme_1.palette.green, 1) : _utils_1.rgba(_theme_1.palette.ink, 0.40);
});
var Label = styled_components_1.default.span.withConfig({
    displayName: "InputSwitch__Label",
    componentId: "q8f1wu-3"
})(["display:block;max-width:280px;", "{max-width:300px;", "}", "{max-width:320px;}"], _utils_1.mediaQuery('laptop'), _theme_1.type.label, _utils_1.mediaQuery('desktop')); // Typing
exports.default = InputSwitch;
